import { createSelector } from 'reselect';

import { getCompany } from './company.selectors';

export const getCompanyNmlsLicenses = createSelector(
  getCompany,
  ({ nmlsLicenses }) => nmlsLicenses,
);
